import React from 'react';
import "../../styles/home/home.css"

export function Home({authState}) {
    return (
        <>

        </>
    );
}
